import React, { useState } from "react";
import { Alert, Button, Card, Form, Input, Typography } from "antd";
import { BankOutlined, LockOutlined, LoginOutlined, SafetyCertificateOutlined, UserOutlined } from "@ant-design/icons";
import { Redirect, useHistory } from "react-router-dom";
import { apiRequest } from "../services/apiClient";
import { useAuth } from "../auth/session";
import { firstAccessiblePath } from "../auth/permissions";

const { Paragraph, Text, Title } = Typography;

export default function SignIn() {
  const history = useHistory();
  const { user, establishSession } = useAuth();
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (user) return <Redirect to={firstAccessiblePath(user)} />;

  async function submit(values) {
    setSubmitting(true);
    setError("");
    try {
      const response = await apiRequest("/api/auth/login", {
        method: "POST",
        skipAuth: true,
        body: JSON.stringify(values),
      });
      const { token, ...profile } = response;
      establishSession(token, profile);
      history.replace(firstAccessiblePath(profile));
    } catch (requestError) {
      setError(requestError.message || "Không thể đăng nhập");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="auth-page auth-login-page">
      <div className="auth-pattern auth-pattern-dots" aria-hidden="true" />
      <div className="auth-pattern auth-pattern-stripes" aria-hidden="true" />
      <Card className="auth-card auth-login-card" bordered={false}>
        <div className="auth-login-logo"><BankOutlined /></div>
        <Text className="auth-login-brand">QUẢN LÝ NGÂN HÀNG</Text>
        <Title level={1}>Chào mừng trở lại</Title>
        <Paragraph className="auth-login-subtitle">
          Đăng nhập để quản lý tài khoản, dòng tiền và chứng từ tập trung.
        </Paragraph>
        {error && <Alert message={error} type="error" showIcon style={{ marginBottom: 16 }} />}
        <Form layout="vertical" onFinish={submit} requiredMark={false}>
          <Form.Item label="TÊN ĐĂNG NHẬP" name="username" rules={[{ required: true, message: "Vui lòng nhập tên đăng nhập" }]}>
            <Input size="large" prefix={<UserOutlined />} placeholder="Nhập tên đăng nhập" autoComplete="username" autoFocus />
          </Form.Item>
          <Form.Item label="MẬT KHẨU" name="password" rules={[{ required: true, message: "Vui lòng nhập mật khẩu" }]}>
            <Input.Password size="large" prefix={<LockOutlined />} placeholder="Nhập mật khẩu" autoComplete="current-password" />
          </Form.Item>
          <Button className="auth-login-submit" type="primary" htmlType="submit" loading={submitting} block>
            Đăng nhập <LoginOutlined aria-hidden="true" />
          </Button>
        </Form>
        <div className="auth-security-note">
          <SafetyCertificateOutlined />
          <span>Hệ thống nội bộ · Mọi thao tác đều được ghi nhật ký</span>
        </div>
      </Card>
    </main>
  );
}
